import { useEffect } from "react";
import { UserColumns, useUsersColumns } from "./columns";
import DataTable from "./data-table";
import { useSelector } from "react-redux";
import { userSelector } from "@/redux/user/user.selector";
import { allUsers as fetchAllUsers } from "@/redux/user/user.action";
import { useAppDispatch } from "@/redux/hooks";
import { TableSkeleton } from "@/components/ui/loading";

const DemoPage = () => {
  const dispatch = useAppDispatch();
  const { allUsers, loading } = useSelector(userSelector).ui;

  const columns = useUsersColumns();

  useEffect(() => {
    dispatch(fetchAllUsers());
  }, [dispatch]);

  const data =
    (allUsers &&
      allUsers.map((user) => ({
        id: user.id,
        username: user.name,
        role: user.role,
        createdBy: user.createdBy,
        email: user.email,
        position: user.position,
        company: user.company,
        suscripciones: user.suscripciones,
      }))) ||
    [];

  return (
    <div className="container pb-10 min-w-full">
      {loading ? (
        <TableSkeleton rows={8} columns={5} />
      ) : (
        <DataTable columns={columns} data={data as UserColumns[]} />
      )}
    </div>
  );
};

export default DemoPage;
